export class ContentfulHeadlineBlock {
    title: string
    text: string
}
